import { atom } from 'jotai';

import { widgetParamsAtom } from './widgetParamsAtom';

const _editorValueAtom = atom<string | undefined>();

export const editorValueAtom = atom(
  (get) => get(_editorValueAtom) ?? JSON.stringify(get(widgetParamsAtom), null, '  '),
  (_get, set, value: string | undefined) => {
    set(_editorValueAtom, value);
  }
);
